/* eslint-disable prettier/prettier */
import axios, { AxiosError, AxiosRequestHeaders } from "axios";
import { captureAxiosError } from "Services/sentry.service";

import { USER_TOKEN } from "../constants";
import deleteAllTokens from "../util/deleteAllTokens";
import env from "../util/env";

const http = axios.create({
  baseURL: env.SEND_EMAIL_API,
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem(USER_TOKEN);

  config = {
    ...config,
    headers: {
      ...(config?.headers || {}),
      Authorization: token || "",
    } as AxiosRequestHeaders,
  };

  return config;
});

http.interceptors.response.use(
  (response) => {
    if (response.status === 401) {
      const shouldSignOut = !response?.data?.message?.toLowerCase().includes("session");

      if (shouldSignOut) {
        deleteAllTokens();
        window.location.replace("/signin");
      }
    }

    return response;
  },
  (error) => {
    const originalStackTrace = error.config?.errorContext?.stack;

    if (originalStackTrace) {
      error.stack = `${error.stack}\n${originalStackTrace}`;
    }

    captureAxiosError(error);

    if (error?.response?.status === 401) {
      const shouldSignOut = !error.response?.data?.message?.toLowerCase().includes("session");

      if (shouldSignOut) {
        deleteAllTokens();
        window.location.replace("/signin");
      }
    }

    throw error;
  }
);

export default http;
